import React, { useEffect, useRef } from 'react';
import { Grid, TextField } from '@mui/material';
import PhoneInput from 'components/masked-input/PhoneInput';
import { PatientValidation } from '../validation/usePatientValidation';
import { Patient } from 'types/patient';
import { asInputComponent } from 'components/masked-input/asInputComponent';

interface PatientContactFormProps {
  patient: Patient;
  handleChange<K extends keyof Patient>(index: K, value: Patient[K]): void;
  validation: PatientValidation;
}

const PatientContactForm: React.FC<PatientContactFormProps> = ({ patient, handleChange, validation }) => {
  const inputs = {
    name: useRef<HTMLInputElement>(null),
    rg: useRef<HTMLInputElement>(null),
    document_number: useRef<HTMLInputElement>(null),
    email: useRef<HTMLInputElement>(null),
    person_type: useRef<HTMLSelectElement>(null),
  };

  useEffect(() => {
    const [key] = Object.keys(validation) as [keyof typeof inputs];

    if (!key) return;

    inputs[key].current?.focus();
  }, [validation]); // eslint-disable-line

  return (
    <Grid container size={12} spacing={2}>
      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          fullWidth
          label="Telefone celular"
          value={patient.phone}
          onChange={e => handleChange('phone', e.target.value)}
          slotProps={{
            input: {
              inputComponent: asInputComponent(PhoneInput),
            },
          }}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          fullWidth
          label="Telefone fixo"
          value={patient.fixed_phone}
          onChange={e => handleChange('fixed_phone', e.target.value)}
          slotProps={{
            input: {
              inputComponent: asInputComponent(PhoneInput),
            },
          }}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          fullWidth
          inputRef={inputs.email}
          label="E-mail"
          value={patient.email}
          onChange={e => handleChange('email', e.target.value)}
          error={!!validation.email}
          helperText={validation.email}
        />
      </Grid>
    </Grid>
  );
};

export default PatientContactForm;
